'use client';

import { faAdd, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@pickleballinc/ui/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogPortal, DialogTitle } from '@pickleballinc/ui/components/ui/dialog';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

import { useCheckIsUserAssociatedWithAnyOrgQuery } from '@/hooks/permission/useCheckIsUserAssociatedWithAnyOrgQuery';
import { publicEnv } from '@/lib/env';
import { getLoginUrl } from '@/utils/getLoginUrl';

export const CreateNewLeagueButton = ({ isUserLogged }: { isUserLogged: boolean }) => {
	const router = useRouter();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { refetch, isLoading } = useCheckIsUserAssociatedWithAnyOrgQuery({ isEnabled: false });

	const handleCreateLeagueClick = async () => {
		if (!isUserLogged) {
			window.location.href = getLoginUrl(publicEnv.NEXT_PUBLIC_PTL_URL);
			return;
		}

		const result = await refetch();
		if (result.data?.data) {
			// User is associated with an organization, redirect to create page
			router.push(`${publicEnv.NEXT_PUBLIC_MANAGE_URL}/team-leagues/create`);
		} else {
			// User is not associated with an organization, show modal
			setIsModalOpen(true);
		}
	};

	const handleRequestClub = () => {
		router.push(`${publicEnv.NEXT_PUBLIC_PC_URL}/create-club`);
	};

	return (
		<>
			<Button
				onClick={handleCreateLeagueClick}
				disabled={isLoading}
				className="flex w-full items-center justify-center gap-2 px-[18px] py-2.5 text-base font-semibold leading-6 text-white md:w-auto"
			>
				<FontAwesomeIcon icon={faAdd} />
				<span>Create New Team League</span>
			</Button>

			<Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
				<DialogPortal>
					<DialogContent className="flex flex-col justify-center w-3/4 sm:w-2/3 rounded-lg md:w-[548px]" hideClose>
						<DialogHeader className="flex flex-col">
							<div className="flex w-full items-center justify-between">
								<DialogTitle className="text-2xl font-medium text-gray-900">Need permission</DialogTitle>
								<FontAwesomeIcon
									icon={faTimes}
									size="xl"
									className="ml-auto cursor-pointer text-gray-500"
									onClick={() => setIsModalOpen(false)}
								/>
							</div>
						</DialogHeader>

						<DialogDescription className="mb-6 mt-4 text-base font-medium text-gray-800">
							All team leagues are created under a club. At this time, you do not have permission in any club to create a team league.
						</DialogDescription>

						<div className="flex gap-2">
							<Button className="flex-1 justify-center" variant="outline" onClick={() => setIsModalOpen(false)}>
								Cancel
							</Button>
							<Button className="flex-1 justify-center" onClick={handleRequestClub}>
								Request a Club
							</Button>
						</div>
					</DialogContent>
				</DialogPortal>
			</Dialog>
		</>
	);
};
